import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StarRatings from 'react-star-ratings';
import { getRequest } from '../../requestUtils';
import { analyticsTrack } from '../../analyticsUtils';
import RegistrationModal from '../RegistrationModal';
import { isMobile } from '../../screenUtils';
import thumbUp from '../../../assets/images/icons/thumbs-up.svg';
import currency from '../../../assets/images/icons/currency-us-gray.svg';
import mapPin from '../../../assets/images/icons/map-pin.svg';
import experience from '../../../assets/images/icons/experience.svg';
import { PROJECT_RECOMMENDED_TAB_LOCATION } from '../../constants';
import './RecommendedConsultantCard.scss';
var yearsToText = function yearsToText(years) {
  switch (years) {
    case 0:
      return ' (<1 yr)';
    case 1:
      return ' (1 yr)';
    default:
      return " (".concat(years, " yrs)");
  }
};
var truncate = function truncate(text, length) {
  return text.length > length ? "".concat(text.slice(0, length), "...") : text;
};
var truncateName = function truncateName(text) {
  return isMobile() ? truncate(text, 15) : truncate(text, 25);
};

// Read invitee email from URL query params to prefill registration email
var invitedEmailFromUrl = typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('email') : null;
var matchingTags = function matchingTags(matchingFrom, matchingAgainst, complex) {
  return matchingFrom.filter(function (t) {
    return matchingAgainst.includes(complex ? t.name : t);
  });
};
var openInNewTab = function openInNewTab(url) {
  var newWindow = window.open(url, '_blank', 'noopener,noreferrer');
  if (newWindow) newWindow.opener = null;
};
var renderStarRatings = function renderStarRatings(rating, compact, company) {
  return /*#__PURE__*/React.createElement("div", {
    className: "rating-avg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "g-row--always lowered-margin"
  }, rating && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(StarRatings, {
    rating: parseFloat(rating),
    starRatedColor: "#FED500",
    starHoverColor: "#FED500",
    starEmptyColor: "#FFFFFF",
    starDimension: "16px",
    starSpacing: "0px",
    numberOfStars: compact ? 1 : 5,
    name: "rating_avg"
  }), /*#__PURE__*/React.createElement("span", {
    className: "rating"
  }, rating)), company && !compact && /*#__PURE__*/React.createElement("span", {
    className: "company ".concat(rating ? '' : 'no-rating')
  }, "".concat(rating ? 'by ' : '').concat(company))));
};
var renderInitialIcon = function renderInitialIcon(initials) {
  return /*#__PURE__*/React.createElement("div", {
    className: "init-icon"
  }, /*#__PURE__*/React.createElement("div", {
    className: "icon-initials"
  }, initials));
};
var renderRoleTag = function renderRoleTag(role, idx) {
  return /*#__PURE__*/React.createElement("div", {
    className: "role-tag",
    key: "".concat(role.name, "-").concat(idx)
  }, "".concat(role.name, " ").concat(role.experience === null ? '' : role.experience));
};
var loadConsultantTags = function loadConsultantTags(consultant, selectedTags) {
  var maxTagsToShow = 4;
  var tags = [];
  tags = tags.concat(consultant.area_of_expertises.map(function (aoe) {
    return aoe.name;
  }), consultant.therapeutic_areas.map(function (ta) {
    return ta.name;
  }), consultant.therapies.map(function (therapy) {
    return therapy.name;
  }), consultant.diseases.map(function (disease) {
    return disease.name;
  }), consultant.development_phases, consultant.degrees, consultant.seniority_levels).sort(function (a, b) {
    if (selectedTags.includes(a) && !selectedTags.includes(b)) {
      return -1;
    }
    if (!selectedTags.includes(a) && selectedTags.includes(b)) {
      return 1;
    }
    return 0;
  });
  return tags.slice(0, maxTagsToShow);
};
var RecommendedConsultantCard = /*#__PURE__*/function (_Component) {
  function RecommendedConsultantCard(props) {
    var _this;
    _classCallCheck(this, RecommendedConsultantCard);
    _this = _callSuper(this, RecommendedConsultantCard, [props]);
    _this.state = {
      proposalRequested: false,
      showRegistrationModal: false,
      callback: function callback() {},
      requestCallbackSelected: false
    };
    _this.loadRequestedStatus = _this.loadRequestedStatus.bind(_this);
    _this.hideModal = _this.hideModal.bind(_this);
    _this.handleRequestProposalClick = _this.handleRequestProposalClick.bind(_this);
    _this.handleViewProfileClick = _this.handleViewProfileClick.bind(_this);
    _this.handleOpenRequestProposal = _this.handleOpenRequestProposal.bind(_this);
    _this.handleOpenViewProfile = _this.handleOpenViewProfile.bind(_this);
    _this.handleShowRegistrationModal = _this.handleShowRegistrationModal.bind(_this);
    return _this;
  }
  _inherits(RecommendedConsultantCard, _Component);
  return _createClass(RecommendedConsultantCard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var projectResourceId = this.props.projectResourceId;
      if (projectResourceId) {
        this.loadRequestedStatus();
      }
    }
  }, {
    key: "loadRequestedStatus",
    value: function loadRequestedStatus() {
      var _this2 = this;
      var _this$props = this.props,
        projectResourceId = _this$props.projectResourceId,
        consultant = _this$props.consultant,
        csrfToken = _this$props.csrfToken;
      getRequest("/projects/".concat(projectResourceId, "/project_invitations"), {
        consultant_resource_id: consultant.resource_id,
        request_proposal: true
      }, csrfToken).then(function (response) {
        var found = response.data.includes(consultant.resource_id);
        _this2.setState({
          proposalRequested: found
        });
      });
    }
  }, {
    key: "hideModal",
    value: function hideModal() {
      this.setState({
        showRegistrationModal: false
      });
    }
  }, {
    key: "handleRequestProposalClick",
    value: function handleRequestProposalClick(event) {
      var _this$props2 = this.props,
        consultant = _this$props2.consultant,
        location = _this$props2.location,
        getEmailStatus = _this$props2.getEmailStatus,
        idx = _this$props2.idx;
      analyticsTrack('Clicked request proposal on recommended consultant card', {
        location: location,
        ConsultantResourceID: consultant.resource_id,
        ClickPosition: idx
      });
      if (getEmailStatus()) {
        if (event.currentTarget.tagName !== 'A') this.handleOpenRequestProposal();
      } else {
        event.preventDefault();
        this.handleShowRegistrationModal(this.handleOpenRequestProposal, true);
      }
    }
  }, {
    key: "handleViewProfileClick",
    value: function handleViewProfileClick(event) {
      var _this$props3 = this.props,
        consultant = _this$props3.consultant,
        location = _this$props3.location,
        getEmailStatus = _this$props3.getEmailStatus,
        idx = _this$props3.idx;
      analyticsTrack('Clicked view profile on recommended consultant card', {
        location: location,
        ConsultantResourceID: consultant.resource_id,
        ClickPosition: idx
      });
      if (getEmailStatus()) {
        if (event.currentTarget.tagName !== 'A') this.handleOpenViewProfile();
      } else {
        event.preventDefault();
        this.handleShowRegistrationModal(this.handleOpenViewProfile, false);
      }
    }
  }, {
    key: "handleOpenRequestProposal",
    value: function handleOpenRequestProposal() {
      openInNewTab(this.requestProposalUrl());
    }
  }, {
    key: "requestProposalUrl",
    value: function requestProposalUrl() {
      var _this$props4 = this.props,
        consultant = _this$props4.consultant,
        location = _this$props4.location,
        filters = _this$props4.filters,
        projectResourceId = _this$props4.projectResourceId;
      var featureParam = '';
      if (location === 'Featured Consultants') {
        featureParam = '?featured=true';
        ['area_of_expertises', 'higher_level_roles', 'therapeutic_areas', 'diseases', 'therapies'].forEach(function (category) {
          if (filters["".concat(category, ".name")]) {
            featureParam += "&".concat(category, "=").concat(filters["".concat(category, ".name")]);
          }
        });
        ['development_phases', 'degrees', 'skills'].forEach(function (category) {
          if (filters[category]) {
            featureParam += "&".concat(category, "=").concat(filters[category]);
          }
        });
        if (filters.seniority_levels) {
          featureParam += "&levels=".concat(filters.seniority_levels);
        }
      } else if (projectResourceId) {
        featureParam = "?project_id=".concat(projectResourceId);
      }
      return "/users/".concat(consultant.resource_id, "/request_proposal").concat(featureParam);
    }
  }, {
    key: "handleOpenViewProfile",
    value: function handleOpenViewProfile() {
      openInNewTab(this.viewProfileUrl());
    }
  }, {
    key: "viewProfileUrl",
    value: function viewProfileUrl() {
      var _this$props5 = this.props,
        consultant = _this$props5.consultant,
        projectResourceId = _this$props5.projectResourceId;
      var fromProject = projectResourceId ? "?project=".concat(projectResourceId) : '';
      return "/users/".concat(consultant.resource_id).concat(fromProject);
    }
  }, {
    key: "handleShowRegistrationModal",
    value: function handleShowRegistrationModal(callback, requestCallbackSelected) {
      var _this$props6 = this.props,
        consultant = _this$props6.consultant,
        location = _this$props6.location,
        idx = _this$props6.idx;
      analyticsTrack('Opened registration modal', {
        location: location,
        ConsultantResourceID: consultant.resource_id,
        ClickPosition: idx
      });
      this.setState({
        showRegistrationModal: true,
        callback: callback,
        requestCallbackSelected: requestCallbackSelected
      });
    }
  }, {
    key: "renderRequestProposal",
    value: function renderRequestProposal() {
      var _this$props7 = this.props,
        consultant = _this$props7.consultant,
        location = _this$props7.location;
      var proposalRequested = this.state.proposalRequested;
      if (proposalRequested) {
        return /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: "btn btn-secondary requested-btn disabled"
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-check proposal-check"
        }), /*#__PURE__*/React.createElement("span", {
          className: "requested-text"
        }, "Proposal Requested"));
      }
      if (location === PROJECT_RECOMMENDED_TAB_LOCATION) {
        return /*#__PURE__*/React.createElement("a", {
          className: "btn btn-primary request-btn",
          href: this.requestProposalUrl(),
          target: "_blank",
          rel: "noopener noreferrer",
          onClick: this.handleRequestProposalClick
        }, "Connect with ".concat(truncateName(consultant.name.split(' ')[0])));
      }
      return /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary request-btn",
        onClick: this.handleRequestProposalClick
      }, "Connect with ".concat(truncateName(consultant.name.split(' ')[0])));
    }
  }, {
    key: "renderTopRatedTag",
    value: function renderTopRatedTag(className) {
      var consultant = this.props.consultant;
      if (consultant.rating_avg > 4) {
        return /*#__PURE__*/React.createElement("div", {
          className: "top-rated-container"
        }, /*#__PURE__*/React.createElement("img", {
          src: thumbUp,
          alt: "thumbs-up",
          className: "thumbs-up ".concat(className)
        }), "Top Rated");
      }
      return null;
    }
  }, {
    key: "renderViewProfileLink",
    value: function renderViewProfileLink(linkText, style) {
      var location = this.props.location;
      if (location !== PROJECT_RECOMMENDED_TAB_LOCATION) {
        return /*#__PURE__*/React.createElement("button", {
          type: "button",
          id: style,
          className: "btn btn-secondary-no-border ".concat(style),
          onClick: this.handleViewProfileClick
        }, linkText);
      }
      return /*#__PURE__*/React.createElement("a", {
        id: style,
        className: "btn btn-secondary-no-border ".concat(style),
        href: this.viewProfileUrl(),
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: this.handleViewProfileClick
      }, linkText);
    }
  }, {
    key: "renderHigherLevelRoles",
    value: function renderHigherLevelRoles() {
      var _this$props8 = this.props,
        consultant = _this$props8.consultant,
        projectRole = _this$props8.projectRole;
      var currentReqRole = null;
      if (projectRole.length > 0) {
        currentReqRole = projectRole[0];
      }
      var reqRole = consultant.higher_level_roles.find(function (role) {
        return role.name === currentReqRole;
      });
      var fullDisplayCount = isMobile() ? 1 : 3;
      return /*#__PURE__*/React.createElement("div", {
        className: "roles-container"
      }, reqRole && renderRoleTag(reqRole, 'req'), consultant.higher_level_roles.filter(function (role) {
        return role !== reqRole;
      }).slice(0, fullDisplayCount).map(function (role, idx) {
        return renderRoleTag(role, idx);
      }), consultant.higher_level_roles.length > fullDisplayCount && renderRoleTag({
        name: "+ ".concat(consultant.higher_level_roles.length - fullDisplayCount, " more"),
        experience: null
      }));
    }
  }, {
    key: "renderProfileHeader",
    value: function renderProfileHeader() {
      var consultant = this.props.consultant;
      return /*#__PURE__*/React.createElement("div", {
        className: "rec-profile-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "name-container"
      }, renderInitialIcon(consultant.initials), this.renderViewProfileLink(truncateName(consultant.name), 'consultant-name'), this.renderTopRatedTag()), this.renderHigherLevelRoles());
    }
  }, {
    key: "renderTestimonial",
    value: function renderTestimonial(className) {
      var consultant = this.props.consultant;
      var review = consultant.latest_review;
      if (!review || !(review.testimonial || review.avg_rating)) {
        return null;
      }
      if (className === 'mobile') {
        return /*#__PURE__*/React.createElement("div", {
          className: "rec-testimonial mobile"
        }, this.renderTopRatedTag(), renderStarRatings(review.avg_rating, true), review.testimonial && /*#__PURE__*/React.createElement("a", {
          href: "/users/".concat(consultant.resource_id, "#reviews"),
          className: "testimonial-link",
          target: "_blank",
          rel: "noopener noreferrer"
        }, "Testimonials"));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "rec-testimonial ".concat(className)
      }, /*#__PURE__*/React.createElement("div", {
        className: "section-header"
      }, "Testimonial"), renderStarRatings(review.avg_rating, false, review.company), review.testimonial && /*#__PURE__*/React.createElement("div", {
        className: "testimonial-review"
      }, "\"".concat(review.testimonial, "\"")));
    }
  }, {
    key: "renderAbout",
    value: function renderAbout() {
      var _this$props9 = this.props,
        consultant = _this$props9.consultant,
        onProjectSharePage = _this$props9.onProjectSharePage;
      if (consultant.bio !== null && consultant.bio.length > 0) {
        return /*#__PURE__*/React.createElement("div", {
          className: "rec-about"
        }, /*#__PURE__*/React.createElement("div", {
          className: "section-header"
        }, "About"), /*#__PURE__*/React.createElement("div", {
          className: "bio-text ".concat(onProjectSharePage && 'bio-text-share-page')
        }, consultant.bio));
      }
      return null;
    }
  }, {
    key: "renderTags",
    value: function renderTags() {
      var _this$props10 = this.props,
        consultant = _this$props10.consultant,
        location = _this$props10.location,
        filters = _this$props10.filters,
        projectPriorityTags = _this$props10.projectPriorityTags,
        projectNonPriorityTags = _this$props10.projectNonPriorityTags;
      var tagsToRender = [];
      var selectedTags = [];
      Object.keys(filters).forEach(function (category) {
        selectedTags = [].concat(_toConsumableArray(selectedTags), _toConsumableArray(filters[category]));
      });
      if (location !== PROJECT_RECOMMENDED_TAB_LOCATION) {
        tagsToRender = filters.length > 0 ? filters : loadConsultantTags(consultant, selectedTags);
      } else {
        tagsToRender = projectPriorityTags.length > 0 ? projectPriorityTags : matchingTags(projectNonPriorityTags, consultant.area_of_expertises, true);
      }
      var numExtraTags = consultant.num_total_tags - tagsToRender.length;
      return /*#__PURE__*/React.createElement("div", {
        className: "rec-qualifications"
      }, tagsToRender.map(function (tag) {
        return /*#__PURE__*/React.createElement("div", {
          className: "rec-qualification-tag ".concat(selectedTags.includes(tag) && 'highlighted'),
          key: tag
        }, selectedTags.includes(tag) ? /*#__PURE__*/React.createElement("i", {
          className: "fa fa-check check-icon"
        }) : '', tag);
      }), numExtraTags > 0 && /*#__PURE__*/React.createElement("div", {
        className: "rec-qualification-tag"
      }, "+ ".concat(numExtraTags, " more")));
    }
  }, {
    key: "renderAvailability",
    value: function renderAvailability() {
      var _this$props11 = this.props,
        consultant = _this$props11.consultant,
        location = _this$props11.location;
      if (consultant.availability && location === PROJECT_RECOMMENDED_TAB_LOCATION) {
        return /*#__PURE__*/React.createElement("div", {
          className: "rec-availability"
        }, "Open to New Projects");
      }
      return null;
    }
  }, {
    key: "renderLogistics",
    value: function renderLogistics() {
      var _this$props12 = this.props,
        consultant = _this$props12.consultant,
        cloraEmployer = _this$props12.cloraEmployer;
      var showCity = consultant.city_location && consultant.city_location.length > 0;
      var showHourlyRate = consultant.minimum_hourly_rate && consultant.maximum_hourly_rate;
      var show = showCity || consultant.years_of_experience || showHourlyRate;
      return /*#__PURE__*/React.createElement("div", {
        className: "rec-logistics ".concat(show ? '' : 'hidden')
      }, showCity && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
        className: "logistics-image",
        src: mapPin,
        alt: "map-pin"
      }), /*#__PURE__*/React.createElement("span", {
        className: "logistics-text"
      }, consultant.city_location)), consultant.years_of_experience && /*#__PURE__*/React.createElement("div", {
        className: "logistics-experience"
      }, /*#__PURE__*/React.createElement("img", {
        className: "logistics-image",
        src: experience,
        alt: "experience"
      }), /*#__PURE__*/React.createElement("span", {
        className: "logistics-text"
      }, "".concat(consultant.years_of_experience, " years experience"))), showHourlyRate && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
        className: "logistics-image",
        src: currency,
        alt: "currency"
      }), /*#__PURE__*/React.createElement("span", {
        className: "logistics-text"
      }, cloraEmployer ? "$".concat(Math.round(consultant.minimum_emp_hourly_rate), " - $").concat(Math.round(consultant.maximum_emp_hourly_rate), " / hr") : "$".concat(Math.round(consultant.minimum_hourly_rate), " - $").concat(Math.round(consultant.maximum_hourly_rate), " / hr"))));
    }
  }, {
    key: "renderRecentCompanies",
    value: function renderRecentCompanies() {
      var consultant = this.props.consultant;
      if (consultant.past_roles.length > 0) {
        return /*#__PURE__*/React.createElement("div", {
          className: "rec-companies"
        }, /*#__PURE__*/React.createElement("div", {
          className: "section-header"
        }, "Recent Companies"), /*#__PURE__*/React.createElement("ul", {
          className: "companies-list"
        }, consultant.past_roles.slice(0, 3).map(function (position, idx) {
          return /*#__PURE__*/React.createElement("li", {
            className: "company",
            key: "".concat(position.company_name, "-").concat(idx)
          }, /*#__PURE__*/React.createElement("span", {
            className: "company-name"
          }, position.company_name), /*#__PURE__*/React.createElement("span", {
            className: "company-years"
          }, yearsToText(position.years_experience)));
        })), this.renderViewProfileLink('View more in profile', 'companies-profile-link'));
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props13 = this.props,
        consultant = _this$props13.consultant,
        location = _this$props13.location,
        csrfToken = _this$props13.csrfToken,
        inviterId = _this$props13.inviterId,
        googleOmniauthUrl = _this$props13.googleOmniauthUrl,
        msOmniauthUrl = _this$props13.msOmniauthUrl,
        signInUrl = _this$props13.signInUrl,
        projectResourceId = _this$props13.projectResourceId;
      var _this$state = this.state,
        showRegistrationModal = _this$state.showRegistrationModal,
        requestCallbackSelected = _this$state.requestCallbackSelected;
      var topOfPage = location === PROJECT_RECOMMENDED_TAB_LOCATION ? '' : 'space-top';
      var searchShowRightPane = location === PROJECT_RECOMMENDED_TAB_LOCATION || consultant.past_roles.length > 0 || consultant.city_location && consultant.city_location.length > 0 || consultant.years_of_experience || consultant.minimum_hourly_rate && consultant.maximum_hourly_rate;
      var searchLeftPaneStyling = searchShowRightPane ? 'border-enabled' : '';
      var searchRightPaneStyling = searchShowRightPane ? '' : 'hidden';
      var consultantParam = "?con_resource_id=".concat(consultant.resource_id);
      var requestParam = requestCallbackSelected ? '&request=true' : '';
      var extraParams = {
        con_resource_id: consultant.resource_id,
        request: requestCallbackSelected
      };
      return /*#__PURE__*/React.createElement("div", {
        className: "rec-consultant-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "rec-consultant-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "rec-consultant-left ".concat(searchLeftPaneStyling)
      }, this.renderProfileHeader(), this.renderLogistics(), this.renderTestimonial('full-view'), this.renderTestimonial('mobile'), this.renderAbout(), this.renderTags(), this.renderRecentCompanies()), /*#__PURE__*/React.createElement("div", {
        className: "rec-consultant-right ".concat(topOfPage, " ").concat(searchRightPaneStyling)
      }, this.renderAvailability(), this.renderLogistics(), this.renderRecentCompanies())), /*#__PURE__*/React.createElement("div", {
        className: "rec-consultant-actions"
      }, this.renderViewProfileLink('View Profile', 'profile-link'), this.renderRequestProposal()), /*#__PURE__*/React.createElement(RegistrationModal, {
        showModal: showRegistrationModal,
        csrfToken: csrfToken,
        hideModal: this.hideModal,
        googleOmniauthUrl: googleOmniauthUrl,
        msOmniauthUrl: msOmniauthUrl,
        signInUrl: "".concat(signInUrl).concat(consultantParam).concat(requestParam),
        extraParams: extraParams,
        header: "Sign up to hire top-tier consultants like ".concat(consultant.name),
        showTestimonials: false,
        location: location,
        inviterId: inviterId,
        projectResourceId: projectResourceId,
        invitedEmail: invitedEmailFromUrl
      }));
    }
  }]);
}(Component);
RecommendedConsultantCard.propTypes = {
  consultant: PropTypes.shape({}).isRequired,
  location: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  projectRole: PropTypes.arrayOf(PropTypes.string),
  projectPriorityTags: PropTypes.arrayOf(PropTypes.string),
  projectResourceId: PropTypes.string,
  projectNonPriorityTags: PropTypes.arrayOf(PropTypes.string),
  idx: PropTypes.number,
  getEmailStatus: PropTypes.func,
  filters: PropTypes.shape({}),
  cloraEmployer: PropTypes.bool.isRequired,
  googleOmniauthUrl: PropTypes.string.isRequired,
  msOmniauthUrl: PropTypes.string.isRequired,
  signInUrl: PropTypes.string.isRequired,
  onProjectSharePage: PropTypes.bool,
  inviterId: PropTypes.string
};
RecommendedConsultantCard.defaultProps = {
  projectRole: [],
  projectPriorityTags: [],
  projectNonPriorityTags: [],
  projectResourceId: null,
  idx: 0,
  getEmailStatus: function getEmailStatus() {
    return null;
  },
  filters: {},
  onProjectSharePage: false,
  inviterId: null,
  location: ''
};
export default RecommendedConsultantCard;